import { SimpleModal, SimpleModalProps } from './simpleModal'
import errorIcon from '../icons/errorIcon.svg'
import { useTranslator } from '../translator/hook'

interface ErrorModalProps
  extends Pick<SimpleModalProps, 'modalTitle' | 'onClose'> {
  error: string | null
}

export const ErrorModal = ({ error, modalTitle, onClose }: ErrorModalProps) => {
  const { t } = useTranslator()

  return (
    <SimpleModal
      imgUrl={errorIcon}
      imgW={57}
      isOpen={!!error}
      modalTitle={modalTitle}
      modalDetail={error ?? ''}
      closeButtonLabel={t('close_button')}
      onClose={onClose}
    />
  )
}
